import ActionType from 'actions/ActionType'

export default (state = false, action) => {
  switch (action.type) {
    case ActionType.Tasks.TOGGLE_SPLIT_FORM:
      return !state
    case ActionType.Tasks.RECEIVE_TASK:
      return Boolean(action.payload)
    default:
      return state
  }
}
